import {initTournamentSeasonSelects} from "../components/tournaments-seasons-selects";

export function initPlayerDetailStats() {
    const mockup = {
        games: 20, // Игр
        swapTo: 3, // Выход на замену
        goals: 1, // Голов
        unrealisedPenalty: 10, //Нереализованные пенальти
        secondYellowCards: 0, //Вторые желтые карточки
        minutes: 1530, // Минут
        swapFrom: 2, // Был заменён
        penalty: 15, // Пенальти
        yellowCards: 0, // Желтые карточки
        redCards: 0, // Красные карточки
        saves: 10, // Сейвы
        shutout: 6, // Сухих матчей
        loosePenalty: 5, // Пропущенные пенальти
        looseGoals: 10, // Пропущенные голы
        winPenalty: 10, // Парированные пенальти
        matches:[
            {
                "amplua": 0,
                "team1":"Нижний Новгород",
                "team2":"Крылья Cоветов",
                "teamLogo1":"./img/icons/events/yellow_red.svg",
                "teamLogo2":"./img/icons/events/yellow_card.svg",
                "score": "1:1",
                "stats": {
                    goals: 0,
                    looseGoals: 1,
                    loosePenalty: 1,
                    minutes: 90,
                    penalty: 0,
                    redCards: 0,
                    saves: 1,
                    secondYellowCards: 0,
                    shutout: 0,
                    swapFrom: 0,
                    swapTo: 0,
                    unrealisedPenalty: 0,
                    winPenalty: 0,
                    yellowCards: 0
                }
            },
            {
                "amplua": 0,
                "lastname": "\u0411\u0430\u0440\u0430\u0447",
                "team1":"Зенит",
                "team2":"К. Советов",
                "teamLogo1":"./img/icons/events/yellow_red.svg",
                "teamLogo2":"./img/icons/events/yellow_card.svg",
                "score": "1:1",
                "stats": {
                    "games": 6,
                    "goals": 1,
                    "lineup": 2,
                    "looseGoals": 2,
                    "loosePenalty": 0,
                    "minutes": 473,
                    "penalty": 1,
                    "redCards": 0,
                    "saves": 0,
                    "secondYellowCards": 0,
                    "shutout": 0,
                    "swapFrom": 0,
                    "swapTo": 1,
                    "unrealisedPenalty": 0,
                    "winPenalty": 0,
                    "yellowCards": 2
                }
            },
        ]
    }

    const $statsList = $('#stats_list');

    if (!$statsList.length) return
    const settings = $statsList.attr('data-settings');
    if (!settings.length) return
    const parsedSettings = JSON.parse(settings);
    let GOALKEEPERS = [];
    let OTHERS = [];

    const fullLineStatisticsValues = {
        games: 0,
        goals: 0,
        looseGoals: 0,
        loosePenalty: 0,
        minutes: 0,
        penalty: 0,
        redCards: 0,
        saves: 0,
        secondYellowCards: 0,
        shutout: 0,
        swapFrom: 0,
        swapTo: 0,
        unrealisedPenalty: 0,
        winPenalty: 0,
        yellowCards: 0
    }

    initTournamentSeasonSelects(parsedSettings, getPlayersDetailStats);
    getPlayersDetailStats();

    function getPlayersDetailStats() {
        GOALKEEPERS = []
        OTHERS = []

        const data = {
            id: +$('[data-player-id]').val() || 0,
            tournamentId: +$('[data-tournament-select]').val(),
            seasonId: +$('[data-season-select]').val()
        }

        $('#stats_block').addClass('load')

        $.ajax({
            url: '/ajax/getPlayerStats/',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            success: (res) => {
                if (!res && !res.length) {
                    renderPlayerStats(mockup);
                    renderStatsList(mockup);
                } else {
                    renderPlayerStats(res)
                    renderStatsList(res);
                }
                setTimeout(() => {
                    $('#stats_block').removeClass('load')
                }, 500)


            },
            error: (res) => {
                renderPlayerStats(mockup);
                renderStatsList(mockup);
                setTimeout(() => {
                    $('#stats_block').removeClass('load')
                }, 500)
            },
            timeout: 30000
        })
    }

    function renderPlayerStats(data) {
        let positiveClass = '';

        clearFinalRowValues();

        for (let key in data) {
            if (data[key] !== null) {
                if (+data[key] === 0) {
                    positiveClass = '';
                } else {
                    positiveClass = 'gradient'
                }
                $('[data-' + key + '] .value').html(data[key]).removeClass('gradient').addClass(positiveClass)
            }
        }
    }

    function renderStatsList(data) {

        for (let i = 0; i < data.matches.length; i++) {
            const item = data.matches[i]
            const amplua = item.amplua
            let stats = item.stats

            if (!Object.keys(stats).length) {
                Object.assign(item.stats, {
                    games: 0,
                    goals: 0,
                    looseGoals: 0,
                    loosePenalty: 0,
                    minutes: 0,
                    penalty: 0,
                    redCards: 0,
                    saves: 0,
                    secondYellowCards: 0,
                    shutout: 0,
                    swapFrom: 0,
                    swapTo: 0,
                    unrealisedPenalty: 0,
                    winPenalty: 0,
                    yellowCards: 0
                })
            }


            if (+amplua === 0) {
                GOALKEEPERS.push(item)
            } else {
                OTHERS.push(item)
            }
        }

        console.log(GOALKEEPERS, OTHERS)

        sortList(GOALKEEPERS, 'number', 'asc')
        sortList(OTHERS, 'number', 'asc')

        if(GOALKEEPERS.length){
            $('[data-goalkeepers-list]').html(renderPlayersList(GOALKEEPERS));
            $('[data-goalkeepers-list]').append(returnFinalRow(true));
            $('[data-others]').hide();

        }else if(OTHERS.length){
            $('[data-others-list]').html(renderPlayersList(OTHERS));
            $('[data-others-list]').append(returnFinalRow(false));
            $('[data-goalkeepers]').hide();

        }else if(!GOALKEEPERS.length && !OTHERS.length){
            $('.all-statistics').hide();
        }
    }

    function renderPlayersList(list) {
        let result = ''
        for (let i = 0; i < list.length; i++) {
            result+=  getStatsPlayerRow(list[i])
        }

        return result
    }

    function getStatsPlayerRow(player) {
        if (!player) return

        const amplua = player.amplua
        const stats = player.stats || null

        const team1 = player.team1;
        const team2 = player.team2;
        const teamLogo1 = player.teamLogo1;
        const teamLogo2 = player.teamLogo2;
        const score = player.score;

        if (!player.stats) return ''

        if (!Object.keys(player.stats).length) return '';

        const minutes = +stats.minutes
        const shutout = +stats.shutout
        const goals = +stats.goals
        const saves = +stats.saves
        const looseGoals = +stats.looseGoals
        const yellowCards = +stats.yellowCards
        const secondYellowCards = +stats.secondYellowCards
        const redCards = +stats.redCards
        const swapTo = +stats.swapTo
        const swapFrom = +stats.swapFrom
        const penalty = +stats.penalty
        const unrealisedPenalty = +stats.unrealisedPenalty

        console.log(looseGoals)

        fullLineStatisticsValues.goals += goals;
        fullLineStatisticsValues.looseGoals += looseGoals;
        fullLineStatisticsValues.loosePenalty += unrealisedPenalty;
        fullLineStatisticsValues.minutes += minutes;
        fullLineStatisticsValues.penalty += penalty;
        fullLineStatisticsValues.redCards += redCards;
        fullLineStatisticsValues.saves += saves;
        fullLineStatisticsValues.secondYellowCards += secondYellowCards;
        fullLineStatisticsValues.shutout += shutout;
        fullLineStatisticsValues.swapFrom += swapFrom;
        fullLineStatisticsValues.swapTo += swapTo;
        fullLineStatisticsValues.unrealisedPenalty += unrealisedPenalty;
        fullLineStatisticsValues.winPenalty += shutout;
        fullLineStatisticsValues.yellowCards +=yellowCards;

        if (+amplua === 0) {
            return ` <div class="statistics-row closed">
                        <div class="item first-item">
                            <div class="flag" style="background-image: url(${teamLogo1})"></div>
                            <div class="team">${team1}</div>
                            <div class="score">${score}</div>
                            <div class="team">${team2}</div>
                            <div class="flag" style="background-image: url(${teamLogo2})"></div>
                            <div class="item-toggle"></div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event stopwatch"></div>
                                Минут на поле
                            </div>
                            <div class="stat-number ${minutes > 0? 'gradient': ''}">${minutes}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-green"></div>
                                Сухих Матчей
                            </div>
                            <div class="stat-number ${shutout > 0? 'gradient': ''}">${shutout}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-gray"></div>
                                Отбитые пенальти
                            </div>
                            <div class="stat-number ${saves > 0? 'gradient': ''}">${saves}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-red"></div>
                                Пропущенные Голы
                            </div>
                            <div class="stat-number ${looseGoals > 0? 'gradient': ''}">${looseGoals}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-card"></div>
                                Желтые карточки
                            </div>
                            <div class="stat-number ${yellowCards > 0? 'gradient': ''}">${yellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-red-card"></div>
                                вторые желтые карточки
                            </div>
                            <div class="stat-number ${secondYellowCards > 0? 'gradient': ''}">${secondYellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event red-card"></div>
                                Красные карточки
                            </div>
                            <div class="stat-number ${redCards > 0? 'gradient': ''}">${redCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-green"></div>
                                Выход на замену
                            </div>
                            <div class="stat-number ${swapTo > 0? 'gradient': ''}">${swapTo}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-red"></div>
                                Был заменен
                            </div>
                            <div class="stat-number ${swapFrom > 0? 'gradient': ''}">${swapFrom}</div>
                        </div>
                    </div>`
        }

        return `<div class="statistics-row closed">
                        <div class="item first-item">
                           <div class="flag" style="background-image: url(${teamLogo1})"></div>
                            <div class="team">${team1}</div>
                            <div class="score">${score}</div>
                            <div class="team">${team2}</div>
                            <div class="flag" style="background-image: url(${teamLogo2})"></div>
                            <div class="item-toggle"></div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event stopwatch"></div>
                                Минут на поле
                            </div>
                            <div class="stat-number ${minutes > 0? 'gradient': ''}">${minutes}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-gray"></div>
                               Голы
                            </div>
                            <div class="stat-number ${goals > 0? 'gradient': ''}">${goals}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-gray"></div>
                                Пенальти
                            </div>
                            <div class="stat-number ${penalty > 0? 'gradient': ''}">${penalty}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-red"></div>
                                нереализованные пенальти
                            </div>
                            <div class="stat-number ${unrealisedPenalty > 0? 'gradient': ''}">${unrealisedPenalty}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-card"></div>
                                Желтые карточки
                            </div>
                            <div class="stat-number ${yellowCards > 0? 'gradient': ''}">${yellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-red-card"></div>
                                вторые желтые карточки
                            </div>
                            <div class="stat-number ${secondYellowCards > 0? 'gradient': ''}">${secondYellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event red-card"></div>
                                Красные карточки
                            </div>
                            <div class="stat-number ${redCards > 0? 'gradient': ''}">${redCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-green"></div>
                                Выход на замену
                            </div>
                            <div class="stat-number ${swapTo > 0? 'gradient': ''}">${swapTo}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-red"></div>
                                Был заменен
                            </div>
                            <div class="stat-number ${swapFrom > 0? 'gradient': ''}">${swapFrom}</div>
                        </div>
                    </div>`
    }

    function returnFinalRow(isGoalkeeper){
        if (isGoalkeeper) {
            return ` <div class="statistics-row closed">
                        <div class="item first-item">
                            <div class="score">Общая статистика</div>
                            <div class="item-toggle"></div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event stopwatch"></div>
                                Минут на поле
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.minutes > 0? 'gradient': ''}">${fullLineStatisticsValues.minutes}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-green"></div>
                                Сухих Матчей
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.shutout > 0? 'gradient': ''}">${fullLineStatisticsValues.shutout}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-gray"></div>
                                Отбитые пенальти
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.saves > 0? 'gradient': ''}">${fullLineStatisticsValues.saves}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-red"></div>
                                Пропущенные Голы
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.looseGoals > 0? 'gradient': ''}">${fullLineStatisticsValues.looseGoals}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-card"></div>
                                Желтые карточки
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.yellowCards > 0? 'gradient': ''}">${fullLineStatisticsValues.yellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-red-card"></div>
                                вторые желтые карточки
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.secondYellowCards > 0? 'gradient': ''}">${fullLineStatisticsValues.secondYellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event red-card"></div>
                                Красные карточки
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.redCards > 0? 'gradient': ''}">${fullLineStatisticsValues.redCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-green"></div>
                                Выход на замену
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.swapTo > 0? 'gradient': ''}">${fullLineStatisticsValues.swapTo}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-red"></div>
                                Был заменен
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.swapFrom > 0? 'gradient': ''}">${fullLineStatisticsValues.swapFrom}</div>
                        </div>
                    </div>`
        }

        return `<div class="statistics-row closed">
                        <div class="item first-item">
                            <div class="score">Общая статистика</div>
                            <div class="item-toggle"></div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event stopwatch"></div>
                                Минут на поле
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.minutes > 0? 'gradient': ''}">${fullLineStatisticsValues.minutes}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-gray"></div>
                               Голы
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.goals > 0? 'gradient': ''}">${fullLineStatisticsValues.goals}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-gray"></div>
                                Пенальти
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.penalty > 0? 'gradient': ''}">${fullLineStatisticsValues.penalty}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-red"></div>
                                нереализованные пенальти
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.unrealisedPenalty > 0? 'gradient': ''}">${fullLineStatisticsValues.unrealisedPenalty}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-card"></div>
                                Желтые карточки
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.yellowCards > 0? 'gradient': ''}">${fullLineStatisticsValues.yellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-red-card"></div>
                                вторые желтые карточки
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.secondYellowCards > 0? 'gradient': ''}">${fullLineStatisticsValues.secondYellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event red-card"></div>
                                Красные карточки
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.redCards > 0? 'gradient': ''}">${fullLineStatisticsValues.redCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-green"></div>
                                Выход на замену
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.swapTo > 0? 'gradient': ''}">${fullLineStatisticsValues.swapTo}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-red"></div>
                                Был заменен
                            </div>
                            <div class="stat-number ${fullLineStatisticsValues.swapFrom > 0? 'gradient': ''}">${fullLineStatisticsValues.swapFrom}</div>
                        </div>
                    </div>`
    }

    function sortList(array, type, direction) {
        if (!type) return

        switch (type) {
            case 'number':
                array.sort((a, b) => +a.number > +b.number ? 1 : -1)
                break

            case 'games':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.games > +b.stats?.games ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.games < +b.stats?.games ? 1 : -1)
                }
                break

            case 'minutes':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.minutes > +b.stats?.minutes ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.minutes < +b.stats?.minutes ? 1 : -1)
                }

                break

            case 'goals':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.goals > +b.stats?.goals ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.goals < +b.stats?.goals ? 1 : -1)
                }
                break

            case 'penalty':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.penalty > +b.stats?.penalty ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.penalty < +b.stats?.penalty ? 1 : -1)
                }
                break

            case 'unrealisedPenalty':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.unrealisedPenalty > +b.stats?.unrealisedPenalty ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.unrealisedPenalty < +b.stats?.unrealisedPenalty ? 1 : -1)
                }
                break

            case 'yellowCards':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.yellowCards > +b.stats?.yellowCards ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.yellowCards < +b.stats?.yellowCards ? 1 : -1)
                }
                break

            case 'secondYellowCards':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.secondYellowCards > +b.stats?.secondYellowCards ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.secondYellowCards < +b.stats?.secondYellowCards ? 1 : -1)
                }
                break

            case 'redCards':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.redCards > +b.stats?.redCards ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.redCards < +b.stats?.redCards ? 1 : -1)
                }
                break

            case 'swapTo':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.swapTo > +b.stats?.swapTo ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.swapTo < +b.stats?.swapTo ? 1 : -1)
                }
                break

            case 'swapFrom':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.swapFrom > +b.stats?.swapFrom ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.swapFrom < +b.stats?.swapFrom ? 1 : -1)
                }
                break

            case 'lineup':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.lineup > +b.stats?.lineup ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.lineup < +b.stats?.lineup ? 1 : -1)
                }
                break

            case 'shutout':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.shutout > +b.stats?.shutout ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.shutout < +b.stats?.shutout ? 1 : -1)
                }
                break

            case 'saves':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.saves > +b.stats?.saves ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.saves < +b.stats?.saves ? 1 : -1)
                }
                break

            case 'looseGoals':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.looseGoals > +b.stats?.looseGoals ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.looseGoals < +b.stats?.looseGoals ? 1 : -1)
                }
                break

            default:
                array.sort((a, b) => +a.number > +b.number ? 1 : -1)
                break
        }
    }

    function rerenderGoalkeepersList() {
        clearFinalRowValues();
        $('[data-goalkeepers-list]').html(renderPlayersList(GOALKEEPERS));
        $('[data-goalkeepers-list]').append(returnFinalRow(true));
    }

    function rerenderOthersList() {
        clearFinalRowValues();
        $('[data-others-list]').html(renderPlayersList(OTHERS));
        $('[data-others-list]').append(returnFinalRow(false));
    }

    function clearFinalRowValues(){
        fullLineStatisticsValues.goals = 0;
        fullLineStatisticsValues.looseGoals = 0;
        fullLineStatisticsValues.loosePenalty = 0;
        fullLineStatisticsValues.minutes = 0;
        fullLineStatisticsValues.penalty = 0;
        fullLineStatisticsValues.redCards = 0;
        fullLineStatisticsValues.saves = 0;
        fullLineStatisticsValues.secondYellowCards = 0;
        fullLineStatisticsValues.shutout = 0;
        fullLineStatisticsValues.swapFrom = 0;
        fullLineStatisticsValues.swapTo = 0;
        fullLineStatisticsValues.unrealisedPenalty = 0;
        fullLineStatisticsValues.winPenalty = 0;
        fullLineStatisticsValues.yellowCards = 0;
    }

    $('body').on('click', '.statistics-head .sort', function () {
        const type = $(this).parents('.statistics-head').attr('data-type')
        const sortType = $(this).attr('data-sort')
        let sortDirection = 'desc'

        if ($(this).hasClass('desc')) {
            $(this).removeClass('desc').addClass('ask')
            sortDirection = 'asc'
        } else {
            $(this).addClass('desc').removeClass('asc')
            sortDirection = 'desc'
        }

        $(this).siblings().removeClass('asc desc')

        if (type === 'goalkeepers') {
            sortList(GOALKEEPERS, sortType, sortDirection)
            rerenderGoalkeepersList()
        } else {
            sortList(OTHERS, sortType, sortDirection)
            rerenderOthersList()
        }

        return false
    })

    $('body').on('click', '.statistics-row .item-toggle', function() {
        const $this = $(this)
        const $parent = $this.parents('.statistics-row')

        $parent.toggleClass('closed')
    })
}
